import { ReactNode } from "react";

import { Skeleton } from "./ui/skeleton";

type PageHeaderProps = {
    title: ReactNode;
    loading?: boolean;
    actions?: ReactNode;
};
export function PageHeader({ title, loading, actions }: PageHeaderProps) {
    return (
        <header className="flex flex-row border-b pb-2">
            {loading ? (
                <Skeleton className="h-8 w-[250px]" />
            ) : (
                <h1 className="text-3xl font-semibold">{title}</h1>
            )}
            {actions ? <div className="ml-auto">{actions}</div> : null}
        </header>
    );
}
